<template>
  <div></div>
</template>

<script>
import axios from '@/assets/axios'

export default {
  created () {
    this.getPdfUrl()
  },
  methods: {
    // 获取pdf地址
    async getPdfUrl () {
      const res = await axios.get(`/letter/getLetterUrlByAccessCode?a=${this.$route.query.a}`, {
        notNeedBaseURL: true
      })
      if (res.data.code === '000000') {
        location.href = res.data.data
      } else {
        this.$router.replace('/landing/intercept')
      }
    }
  }
}
</script>